module.exports = __webpack_public_path__ + "fonts/PTC75F-webfont.3cb93a1.woff";